/**
 * SDK 登录/短信码/手机号加密 API(同源 BFF 调用)
 *
 * 走 hotel-hub 同源 BFF /api/auth/*(BFF callUpstream 服务端推导 hotelId/tenant/brand -> whapi,
 * 公开 whapi 端点无 X-API-Key)。用 sdk client 的 post(自动带 basePath + domain 透传)。
 * loginWithSms 返回的 token 由 BFF 透传响应体,SDK 侧 onLoginSuccess 原样写入 user-storage
 * (行为同主流程 login(),格式匹配 zustand persist)。
 */
import type {
  EncryptPhoneRequest,
  EncryptPhoneResponse,
  SendSmsParams,
  LoginParams,
  LoginResponse,
} from '@/types/auth';
import { post } from './client';

/** DES 加密手机号 */
export function encryptPhone(params: EncryptPhoneRequest): Promise<EncryptPhoneResponse> {
  return post<EncryptPhoneResponse>('/api/auth/encrypt-phone', params);
}

/** 发送短信验证码(参数含加密手机号 + 滑块验证令牌) */
export function sendSmsCode(params: SendSmsParams): Promise<{ success: boolean }> {
  return post('/api/auth/sms-code', params);
}

/** 短信登录(返回 token + user,SDK 侧 onLoginSuccess 写入 user-storage) */
export function loginWithSms(params: LoginParams): Promise<LoginResponse> {
  return post<LoginResponse>('/api/auth/login', params);
}
